<template slot-scope="props">
  <div class="animated fadeIn">
    
    <form>
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
             <div class="p-4 d-flex align-items-center justify-content-between" 
                  :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
                <div>
                  <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                    <i class='fa fa-file-text-o mr-2'></i>Relatório de Vendas
                  </h4>
                  <span class="text-muted d-block">Configure os filtros abaixo para gerar seu documento personalizado.</span>
                </div>
            </div>



            <!-- Seção 1: Tipo de Relatório -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="tipoRelatorio" description="Selecione o formato dos dados para le relatório." :class="isDark ? 'text-light' : ''">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Entidades e Pessoas -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Pessoas e Filtros Principais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Cliente">
                    <cliente-pesquisa 
                      @retornaId="COD_CLI = $event"
                      :idInicial="COD_CLI"
                      :desabilitarInput="!habilitaCOD_CLI"
                      label=""
                      place="Todos os clientes (opcional)"
                      labelBotao=""
                      ref="clientePesquisa"
                      idModal="clienteModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Vendedor">
                    <vendedor-dropdown 
                      v-model="VENDEDOR_ID"
                      :disabled="!habilitaCOD_VENDEDOR"
                      ref="vendedorPesquisa"
                      placeholder="Todos os vendedores (opcional)"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Conferente">
                    <funcionario-dropdown
                      v-model="CONFERENTE_ID"
                      :disabled="!habilitaCOD_CONFERENTE"
                      ref="conferentePesquisa"
                      placeholder="Todos os conferentes (opcional)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Motorista">
                    <funcionario-dropdown
                      v-model="MOTORISTA_ID"
                      :disabled="!habilitaCOD_MOTORISTA"
                      ref="motoristaPesquisa"
                      placeholder="Todos os motoristas (opcional)"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Produtos e Estoque -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cubes mr-2"></i>Produtos e Estoque</h6>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="PRODUTO_ID = $event"
                      :idInicial="PRODUTO_ID"
                      :desabilitarInput="!habilitaCOD_PRO"
                      label=""
                      place="Filtrar por Produto"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Centro Estoque">
                    <centro-estoque-drop-down
                      v-model="CENTRO_ESTOQUE_ID"
                      :disabled="!habilitaCENTRO_ESTOQUE_ID"
                      ref="centroEstoquePesquisa"
                      placeholder="Todos os centros"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="GRUPO_PRODUTO_ID"
                      :disabled="!habilitaGRUPO_PRODUTO_ID"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 4: Período e Intervalo -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período e Intervalo</h6>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Forma de Intervalo">
                      <b-form-select :plain="true" v-model="tipoPeriodo.valor" :options="tipoPeriodo.opcoes" />
                  </b-form-group>
                </b-col>
                
                <b-col md="4" sm="6" v-if="tipoPeriodo.valor == 'D' ">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="DT1" :state="DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6" v-if="tipoPeriodo.valor == 'D' ">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="DT2" :state="DT2 ? null : false" />
                  </b-form-group>
                </b-col>

                <b-col md="4" sm="6" v-if="tipoPeriodo.valor == 'N' ">
                  <b-form-group label="N. Controle Início">
                    <b-form-input type="text" id="inicioId" placeholder="N. Início" v-model="ID1" :class="{ 'is-invalid': !ID1 }" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6" v-if="tipoPeriodo.valor == 'N' ">
                  <b-form-group label="N. Controle Fim">
                    <b-form-input type="text" id="terminoId" placeholder="N. Fim" v-model="ID2" :class="{ 'is-invalid': !ID2 }" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 5: Configurações Adicionais e Ordenação -->
            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Configurações e Ordenação</h6>
              <b-row>
                <b-col md="3" sm="6">
                  <b-form-group label="Pagamento">
                      <b-form-select 
                          :plain="true"  
                          :disabled="habilitaFormaPagamento"
                          v-model="formaPagamento.valor" 
                          :options="formaPagamento.opcoes">
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Ordenação">
                      <b-form-select :plain="true" v-if="(['1','2','3','4','5','6','7'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoes" />
                      <b-form-select :plain="true" v-else-if="(['8','9','10'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumulado" />
                      <b-form-select :plain="true" v-else-if="(['11'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoGrupo" />
                      <b-form-select :plain="true" v-else-if="(['12'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoClienteProduto" />
                      <b-form-select :plain="true" v-else-if="(['13'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoClienteGrupoProduto" />
                      <b-form-select :plain="true" v-else-if="(['14'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoCliente" />
                      <b-form-select :plain="true" v-else-if="(['15'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoVendedor" />
                      <b-form-select :plain="true" v-else-if="(['16'].includes(tipoRelatorio))" v-model="ordem.valor" :options="ordem.opcoesAcumuladoVendedorProduto" />
                      <b-form-select :plain="true" v-else v-model="ordem.valor" :options="ordem.opcoes" />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Filtra Boleto">
                      <b-form-select :plain="true" v-model="tipoBoleto.valor" :options="tipoBoleto.opcoes" />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Outras Opções">
                      <b-form-select :plain="true" v-model="outros.valor" :options="outros.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

                        <div class="card-footer-action p-4 text-center mt-2" :class="isDark ? 'bg-dark-darker' : 'bg-white'">
               <b-button size="lg" type="button" variant="primary" @click.stop.prevent="imprimir()" class="px-5 py-3 btn-pill shadow-lg btn-generate">
                  <i class="fa fa-print mr-2"></i> GERAR RELATÓRIO DE VENDAS
               </b-button>
            </div>

          </b-card>
          
        </b-col>
      </b-row>
    </form>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import VendedorDropdown from '../componentes/dropdown/VendedorDropdown.vue'
import FuncionarioDropdown from '../componentes/dropdown/FuncionarioDropdown.vue'
import CentroEstoqueDropDown from '../componentes/dropdown/CentroEstoqueDropDown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    VendedorDropdown,
    ClientePesquisa,
    FuncionarioDropdown,
    CentroEstoqueDropDown,
    ProdutoPesquisa,
    GrupoProdutoDropDown,
    CecInputData
  },
  data () {
    return {
      teste : 'xxx',
      COD_CLI: null,
      VENDEDOR_ID: null,
      CONFERENTE_ID: null,
      MOTORISTA_ID: null,
      PRODUTO_ID: null,
      CENTRO_ESTOQUE_ID: null,
      GRUPO_PRODUTO_ID: null,
      ID1: null,
      ID2: null,
      DT1: moment().format('YYYY-MM-DD'),
      DT2: moment().format('YYYY-MM-DD'),
      

      parametros: {
        nomeCliente: '',
        nomeVendedor: '',
        nomeGrupoProduto: '',
        nomeMotorista: '',
        nomeCentroEstoque: '',
        nomeProduto: '',
      },
      tipoRelatorio: '1',
      outros: {
        opcoes: [
          { value: 'X', text: 'Vendas e Trocas' },
          { value: 'V', text: 'Somente Vendas' },
          { value: 'T', text: 'Somente Trocas' },
          { value: 'C', text: 'Somente Canceladas' }
        ],
        valor: 'V'
      },
      formaPagamento: {
        opcoes: [
          { value:  '', text: 'Todos' },
          { value: 'V', text: 'A Vista' },
          { value: 'P', text: 'A Prazo' }
        ],
        valor: ''
      },
      tipoPeriodo: {
        opcoes: [
          { value: 'D', text: 'Por Data' },
          { value: 'N', text: 'Por Número de Controle' }
        ],
        valor: 'D'
      },
      tipoBoleto: {
        opcoes: [
          { value:  '', text: '' },
          { value: '1', text: 'Somente vendas com boletos' },
          { value: '2', text: 'Somente vendas sem boletos' }
        ],
        valor: ''
      },
      ordem: {
        opcoes: [
          { value: '1', text: 'Data Venda e Controle' },
          { value: '2', text: 'Data Venda e Cliente' },
          { value: '3', text: 'Cliente e Data da Venda' }
        ],
        opcoesAcumulado: [
          { value: '1', text: 'Nome do Produto' },
          { value: '2', text: 'Quantidade de Saida' },
          { value: '3', text: 'Valor Total' }
        ],
        opcoesAcumuladoGrupo: [
          { value: '1', text: 'Nome do Grupo e Nome Produto' },
        ],
        opcoesAcumuladoClienteProduto: [
          { value: '1', text: 'Nome Cliente e Nome Produto' },
        ],
        opcoesAcumuladoClienteGrupoProduto: [
          { value: '1', text: 'Nome Cliente e Nome Grupo' },
        ],
        opcoesAcumuladoCliente: [
          { value: '1', text: 'Nome do Cliente'},
          { value: '2', text: 'Valor Vendido'},
          { value: '3', text: 'Quantidade Vendida'}
        ],
        opcoesAcumuladoVendedor: [
          { value: '1', text: 'Nome do Vendedor'},
          { value: '2', text: 'Valor Vendido'},
          { value: '3', text: 'Quantidade Vendida'}
        ],
        opcoesAcumuladoVendedorProduto: [
          { value: '1', text: 'Vendedor, Grupo de Produtos e Produto' }
        ],
        valor: '1'
      }
    }
  },
  methods: {
    getLabelFromDropDown (refName, value) {
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    },
    imprimir () {
     
      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true
      this.parametros.nomeCliente = ''
      this.parametros.nomeFuncionario = ''

      const params = {
        dt1: this.DT1,
        dt2: this.DT2,
        clienteId: this.COD_CLI || '',
        lbCliente: this.$refs.clientePesquisa?.$refs?.auto?.display || '',
        vendedorId: this.VENDEDOR_ID || '',
        lbVendedor: this.getLabelFromDropDown('vendedorPesquisa', this.VENDEDOR_ID),
        conferenteId: this.CONFERENTE_ID || '',
        lbConferente: this.getLabelFromDropDown('conferentePesquisa', this.CONFERENTE_ID),
        motoristaId: this.MOTORISTA_ID || '',
        lbMotorista: this.getLabelFromDropDown('motoristaPesquisa', this.MOTORISTA_ID),
        produtoId: this.PRODUTO_ID || '',
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
        lGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID),
        centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
        lbCentroEstoque: this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID),
        tipoBoleto: this.tipoBoleto.valor,
        formaPagamento: this.formaPagamento.valor || '',
        tipoPeriodo: this.tipoPeriodo.valor,
        outros: this.outros.valor,
        ordem: this.ordem.valor,
        lbEmpresa: window.localStorage.getItem('nomeempresa') || '',
        lbUsuario: window.localStorage.getItem('nomeusuario') || '',
        tipoRel: this.tipoRelatorio
      }

      if (this.tipoPeriodo.valor === 'N') {
        params.id1 = this.ID1 || ''
        params.id2 = this.ID2 || ''
      }

      const uri = '/api/protected/relatorios/venda/analitico?' + new URLSearchParams(params).toString()
        
      this.$http.get(uri, {responseType: 'arraybuffer'})
      .then(response => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast('Relatório Gerado com Sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'relVendaAnalitico.pdf') 
        link.download = 'RelVendaAnalitico.pdf'
        // document.body.appendChild(link)
        //link.click()
        // document.body.removeChild(link)
        const janela = window.open(link)
        /*
        setTimeout(() =>
          { 
              janela.document.title = 'Relatório de Vendas'; 
          }, 1000);
          */
        janela.onload = function(){
          setTimeout(() => {
            janela.document.title = id +' Relatório de Vendas Analitico'
          }, 2000);
        }
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(erro => {
        this.$toast.error({
          title: 'Erro',
          message: 'Ocorreram erros ao gerar o Relatorio ',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        this.$store.commit('controle/setAguardando', false)
      })
    }
  },
  
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    isVendedor () {
      return (( localStorage.getItem("vendedorId") == undefined ) || ( localStorage.getItem("vendedorId") == '100' )) ? false : true
    },
    habilitaCOD_CLI () {
        return ['1','2','3','4','5','6','7','8','9','10','11','12','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaCOD_CONFERENTE () {
        return ['1','2','3','4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaCOD_VENDEDOR () {
       if (( localStorage.getItem("vendedorId") == undefined ) || ( localStorage.getItem("vendedorId") == '100' ))  {
        console.log( localStorage.getItem("vendedorId") )
        console.log(localStorage.getItem("vendedorId") == '100')
        console.log(11111)
        return ['1','2','3','4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
       } else {
        console.log(2222)
        return false
       }
    },
    habilitaCOD_PRO () {
        return ['4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaCENTRO_ESTOQUE_ID () {
        return ['4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaGRUPO_PRODUTO_ID () {
        return ['4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaCOD_MOTORISTA () {
        return ['4','5','6','7','8','9','10','11','15','16'].includes(this.tipoRelatorio) ? true : false
    },
    habilitaFormaPagamento () {
        return ['8','9','10','11'].includes(this.tipoRelatorio) ? true : false
    },
    opcoesRelatorio () {
      let opcoes = [
        { value: '1', text: 'Sintético' },
        { value: '3', text: 'Sintético Financeiro' },
        { value: '4', text: 'Analítico' },
        { value: '8', text: 'Acumulado - Produtos' },
        { value: '11', text: 'Acumulado - Grupo de Produtos' }
      ]

      if (!this.isVendedor) {
        opcoes.push({ value: '2', text: 'Sintético com Custo' })
        opcoes.push({ value: '5', text: 'Analítico com Custo' })
        opcoes.push({ value: '6', text: 'Analítico Financeiro' })
        opcoes.push({ value: '7', text: 'Analítico Dif. Retorno Entrega' })
        opcoes.push({ value: '9', text: 'Acumulado - Produtos com Custo' })
        opcoes.push({ value: '10', text: 'Acumulado - Produtos Dif. Retorno Entrega' })
        opcoes.push({ value: '12', text: 'Acumulado - Cliente e Produto' })
        opcoes.push({ value: '13', text: 'Acumulado - Cliente e Grupo' })
        opcoes.push({ value: '14', text: 'Acumulado - Cliente' })
        opcoes.push({ value: '15', text: 'Acumulado - Vendedor' })
        opcoes.push({ value: '16', text: 'Acumulado - Vendedor por Produto' })
      }

      // Ordenar por valor para manter uma ordem lógica ou por texto?
      // Vou ordenar por valor para manter a ordem original
      return opcoes.sort((a, b) => parseInt(a.value) - parseInt(b.value))
    },

    isValid () {
      if ((this.tipoRelatorio === '1') || (this.tipoRelatorio === '2')) {
        return !!this.COD_CLI && !!this.VENDEDOR_ID && !!this.GRUPO_PRODUTO_ID && !!this.DT1 && !!this.DT2
      } else {
        return !!this.DT1 && !!this.DT2
      }
    }
  },
  
  watch: {
    'tipoRelatorio': function () {
      if (!['1','2','3'].includes(this.tipoRelatorio)) {
        this.PRODUTO_ID = null
        this.CENTRO_ESTOQUE_ID = null
        this.GRUPO_PRODUTO_ID = null
      } else if (!['8','9','10'].includes(this.tipoRelatorio)) {
        this.formaPagamento.valor = null
      }
    }
  },
  created () {
    if (this.isVendedor) {
      console.log('existe vendedor')
      this.VENDEDOR_ID = localStorage.getItem("vendedorId")
    }
  }
}
</script>

<style scoped>
.bg-primary-soft { background-color: rgba(32, 168, 216, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-light-gray { background-color: #f8f9fa; }
.bg-dark-lighter { background-color: #2f353a; }
.bg-dark-darker { background-color: #1e2225; }

.bg-light-rounded {
  background: rgba(0,0,0,0.03); 
  border-radius: 6px;
}

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ebedef;
  transition: all 0.3s ease;
}

.section-container.dark-mode {
  background: #23282c;
  border-color: #3a4149;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  background: #ffffff;
}

.section-container.dark-mode:hover {
  background: #2f353a;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #63c2de;
}

.select-premium {
  border: 1px solid #20a8d8;
  color: #20a8d8;
  font-weight: 600;
  cursor: pointer;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  transition: transform 0.2s ease;
}

.btn-generate:hover {
  transform: translateY(-2px);
}

hr {
  border-top: 1px solid #ebedef;
}

hr.border-secondary {
  border-color: #3a4149 !important;
}

.form-group label {
  font-weight: 600;
  color: #4f5d73;
  margin-bottom: 0.5rem;
}

.dark-mode .form-group label {
  color: #c8ced3;
}
</style>





// WEBPACK FOOTER //
// src/views/relatorios/RelVendas.vue